import { Shop, Staff, RepairJob, JobStatus, Service, Transaction, ServiceItem, Discount, Rating, Reminder } from './types';

export const SERVICE_CATEGORIES = [
  'Air Conditioner',
  'Refrigerator',
  'Washing Machine',
  'Electronics',
  'Computers',
  'Automotive',
  'Plumbing',
  'General Repair',
  'Bicycles',
  'Appliances'
];

// Valid UUID placeholders for mock data to satisfy Postgres UUID constraints
export const MOCK_SHOP_ID = '00000000-0000-0000-0000-000000000001';
export const MOCK_STAFF_ID = '00000000-0000-0000-0000-000000000002';
export const MOCK_USER_ID = '00000000-0000-0000-0000-000000000003';

// Helper to generate a valid-looking UUID
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

const SHOP_IMAGES = [
  'https://images.unsplash.com/photo-1591485162788-294b4194c77c?auto=format&fit=crop&q=80&w=600',
  'https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&q=80&w=600',
  'https://images.unsplash.com/photo-1581092921461-eab62e97a783?auto=format&fit=crop&q=80&w=600'
];

export const formatRiel = (amount: number): string => {
  return new Intl.NumberFormat('en-KH').format(Math.round(amount)) + ' ៛';
};

const today = new Date().toISOString().split('T')[0];

export const MOCK_SHOPS: Shop[] = [
  {
    id: MOCK_SHOP_ID,
    name: 'Tech Healers',
    category: ['Electronics'],
    rating: 4.8,
    address: '#123, St 2004, Phnom Penh',
    imageUrl: SHOP_IMAGES[0],
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/3655/3655583.png',
    description: 'Expert repair for smartphones.',
    contact: { phone: '+855 12 345 678' },
    workingHours: '8:00 AM - 8:00 PM',
    coordinates: { lat: 11.5564, lng: 104.9282 },
    vatPercentage: 0
  }
];

export const MOCK_STAFF: Staff[] = [];
export const MOCK_SERVICES: Service[] = [];
export const MOCK_JOBS: RepairJob[] = [];
export const MOCK_TRANSACTIONS: Transaction[] = [];
export const MOCK_DISCOUNTS: Discount[] = [];
export const MOCK_RATINGS: Rating[] = [];
export const MOCK_REMINDERS: Reminder[] = [];